import React from 'react'
import styled from 'styled-components'
import { devices } from 'Utils/devices'

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height:  75px;  
`

const SVG = styled.svg`
  ${({isFromWidgetChoice}) => isFromWidgetChoice && `
    @media ${devices.tablet} {
      width: 75px; 
      height: 48;
    }`
  }
`

const ChartTableIcon = ({
  isFromWidgetChoice
}) => (
  <IconContainer>
    <SVG xmlns="http://www.w3.org/2000/svg" width="97" height="54" viewBox="0 0 97 54" isFromWidgetChoice={isFromWidgetChoice}>
      <g id="charttable" transform="translate(-833.5 -196.5)">
        <line id="Ligne_473" dataname="Ligne 473" y2="14" transform="translate(864.5 216.5)" fill="none" stroke="currentColor" strokeWidth="2"/>
        <line id="Ligne_479" dataname="Ligne 479" y2="14" transform="translate(895.5 216.5)" fill="none" stroke="currentColor" strokeWidth="2"/>
        <line id="Ligne_475" dataname="Ligne 475" x1="97" transform="translate(833.5 233.5)" fill="none" stroke="currentColor" strokeWidth="2"/>
        <line id="Ligne_476" dataname="Ligne 476" x1="97" transform="translate(833.5 213.5)" fill="none" stroke="currentColor" strokeWidth="2"/>
        <line id="Ligne_474" dataname="Ligne 474" y2="14" transform="translate(864.5 236.5)" fill="none" stroke="currentColor" strokeWidth="2"/>
        <line id="Ligne_480" dataname="Ligne 480" y2="14" transform="translate(895.5 236.5)" fill="none" stroke="currentColor" strokeWidth="2"/>
        <line id="Ligne_477" dataname="Ligne 477" x2="17" transform="translate(838.5 203.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="5"/>
        <line id="Ligne_481" dataname="Ligne 481" x2="17" transform="translate(871.5 203.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="5"/>
        <line id="Ligne_482" dataname="Ligne 482" x2="17" transform="translate(903.5 203.5)" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="5"/>
        <line id="Ligne_483" dataname="Ligne 483" y2="14" transform="translate(864.5 196.5)" fill="none" stroke="currentColor" strokeWidth="2"/>
        <line id="Ligne_484" dataname="Ligne 484" y2="14" transform="translate(895.5 196.5)" fill="none" stroke="currentColor" strokeWidth="2"/>
      </g>
    </SVG>
  </IconContainer>
)

export default ChartTableIcon